import libphonenumber from 'google-libphonenumber'

const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance()
const allowType = [
  // 市話部分阻擋，留手機
  // libphonenumber.PhoneNumberType.FIXED_LINE,
  libphonenumber.PhoneNumberType.MOBILE,
  libphonenumber.PhoneNumberType.FIXED_LINE_OR_MOBILE,
]

const { countryCodeToRegionCodeMap } = libphonenumber.metadata
const regionCodeToCountryCodeMap = Object.keys(countryCodeToRegionCodeMap).reduce((result, key) => {
  countryCodeToRegionCodeMap[key].forEach((regionCode) => {
    result[regionCode] = key
  })
  return result
}, {})

function isValid(phone) {
  try {
    const number = phoneUtil.parseAndKeepRawInput(phone)
    return phoneUtil.isValidNumber(number) && allowType.includes(phoneUtil.getNumberType(number))
  } catch (e) {
    return false
  }
}

function getNationalNumber(phone) {
  const number = phoneUtil.parseAndKeepRawInput(`+${phone}`)
  return number.getNationalNumber()
}

function getCountryCode(region) {
  return regionCodeToCountryCodeMap[region]
}

export default { isValid, getNationalNumber, getCountryCode }
